import React from "react";
//import { useState } from "react";
import '../../styles/Find-Car-Form.css';
//import { useNavigate } from 'react-router-dom';
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" />

const FindCarForm = () => {
    return (
        <div>

        </div>
    )
};

export default FindCarForm;